import { apiClient } from './client';
import { DashboardStats } from '../types';

export const dashboardApi = {
  getStats: (): Promise<DashboardStats> => {
    return apiClient.get<DashboardStats>('/admin/dashboard/stats');
  }
};

